import React, { useState, useContext, useEffect } from 'react';
import useDebouncedCallback from 'use-debounce/lib/callback';
import ReactEcharts from 'echarts-for-react';

import Navigation from '../Navigation';
import ProductLayer from '../../components/ProductLayer';

import FilteredContext from '../../contexts/FilteredContext';
import API from '../../services/API';

const Chart = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { filters } = useContext(FilteredContext);
  const [extraInfoId, setExtraInfoId] = useState(null);

  const [loadContentDebounced] = useDebouncedCallback(
    async (reqFilters) => {
      const result = await API.getSunburstData(reqFilters);
      if (!result) {
        return;
      }
      setData(result);
      setLoading(false);
    },
    500,
    [],
  );

  const loadContent = () => {
    if (!loading) {
      setLoading(true);
    }
    loadContentDebounced(filters);
  };

  useEffect(() => {
    loadContent();
  }, [filters]);

  const handleUnderlyingClick = (name) => {
    setExtraInfoId(name);
  };

  return (
    <>
      <div style={{ height: '600px', marginBottom: '400px', marginTop: '40px', position: 'relative' }}>
        <ReactEcharts
          option={{
            animation: false,
            series: {
              type: 'sunburst',
              highlightPolicy: 'ancestor',
              data,
              radius: [0, '95%'],
              sort: null,
              levels: [
                {},
                {
                  r0: '5%',
                  r: '46%',
                  label: {
                    align: 'center',
                  },
                  itemStyle: {
                    borderWidth: 2,
                  },
                },
                {
                  r0: '46%',
                  r: '86%',
                  label: {
                    align: 'right',
                  },
                },
                {
                  r0: '86%',
                  r: '87%',
                  label: {
                    position: 'outside',
                    padding: 0,
                    silent: false,
                  },
                  itemStyle: {
                    borderWidth: 1,
                  },
                },
              ],
            },
          }}
          notMerge
          lazyUpdate
          onChartReady={() => true}
          onEvents={{
            click: (params) => {
              if (params.treePathInfo.length === 3) {
                handleUnderlyingClick(params.name);
              }
            },
          }}
          opts={null}
          style={{ height: '600px' }}
          showLoading={loading}
          loadingOption={{
            text: '',
            color: '#2DCCD3',
            maskColor: '#5b677066',
          }}
        />
        {extraInfoId ? (
          <ProductLayer
            product={{
              name: extraInfoId,
            }}
            onEsc={() => setExtraInfoId(null)}
            onClickOutside={() => setExtraInfoId(null)}
          />
        ) : (
          ''
        )}
      </div>
    </>
  );
};

const Content2 = () => {
  const [filters, setFilters] = useState([]);
  return (
    <>
      <FilteredContext.Provider value={{ filters, setFilters }}>
        <Navigation />
        <Chart />
      </FilteredContext.Provider>
    </>
  );
};

export default Content2;
